
import { Component, Vue } from 'vue-property-decorator'
import { useCultureSubsidyStore } from '@/stores/cultureSubsidy'
import { MovementType, ReserveMovement } from '../types'

@Component({ name: 'HistoryPanel' })
export default class extends Vue {
  store = useCultureSubsidyStore()
  search = ''
  typeFilter: MovementType | '' = ''
  range: Date[] | null = null

  types: MovementType[] = [
    'feed_wire',
    'feed_from_free',
    'feed_from_loyalty',
    'feed_from_recycling',
    'empty_to_free',
    'debit_cashback',
    'cancel_cashback'
  ]

  get filtered(): ReserveMovement[] {
    return this.store.movements.filter(movement => {
      if (this.typeFilter && movement.type !== this.typeFilter) return false
      if (this.range && this.range.length === 2) {
        const time = new Date(movement.date).getTime()
        if (time < this.range[0].getTime() || time > this.range[1].getTime() + 86400000) return false
      }
      if (this.search) {
        const q = this.search.toLowerCase()
        const blob = `${movement.comment || ''} ${movement.beneficiaryName || ''} ${movement.orderRef || ''}`.toLowerCase()
        if (!blob.includes(q)) return false
      }
      return true
    })
  }

  get grouped(): { day: string; label: string; items: ReserveMovement[] }[] {
    const map = new Map<string, ReserveMovement[]>()
    this.filtered.forEach(movement => {
      const day = movement.date.slice(0, 10)
      const list = map.get(day) || []
      list.push(movement)
      map.set(day, list)
    })
    return Array.from(map.entries()).map(([day, items]) => ({
      day,
      label: this.$moment(day).format('dddd D MMMM YYYY'),
      items
    }))
  }

  exportCsv(): void {
    const headers = ['date', 'type', 'montant', 'poche', 'commande', 'beneficiaire', 'commentaire']
    const rows = this.filtered.map(movement => [
      movement.date,
      movement.type,
      String(movement.amount).replace('.', ','),
      movement.pocket,
      movement.orderRef || '',
      movement.beneficiaryName || '',
      (movement.comment || '').replace(/;/g, ',')
    ].map(value => `"${value}"`).join(';'))
    const csv = [headers.join(';'), ...rows].join('\n')
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = `historique_subvention_culture_${new Date().toISOString().slice(0, 10)}.csv`
    link.click()
  }
}
